import type { ThemeConfig } from './theme'

/** Đồng bộ token shell logistics (`--ui-*`) từ theme nhansu (`--color-*`). */
export const syncUiCssVars = (config: ThemeConfig): void => {
  if (typeof document === 'undefined') return
  const root = document.documentElement
  const set = (name: string, value: string) => root.style.setProperty(name, value)

  set('--ui-primary-main', config['--color-primary'])
  set('--ui-primary-dark', config['--color-sidebar-active-text'])
  set('--ui-primary-light', config['--color-btn-primary-hover'])
  set('--ui-primary-surface', config['--color-sidebar-nested-bg'])
  set('--ui-primary-surface-border', config['--color-sidebar-nested-border'])

  set('--ui-neutral-background', config['--color-content-bg'])
  set('--ui-neutral-background-deep', '#f1f5f9')
  set('--ui-neutral-border', 'rgba(15, 23, 42, 0.06)')
  set('--ui-neutral-border-medium', 'rgba(15, 23, 42, 0.1)')
  set('--ui-neutral-text', '#0f172a')
  set('--ui-neutral-text-muted', '#64748b')
  set('--ui-neutral-text-subtle', '#94a3b8')

  set('--ui-shell-header-solid', config['--color-navbar-bg'])
  set('--ui-shell-header-border', 'rgba(255, 255, 255, 0.14)')
  set('--ui-shell-header-shadow', '0 1px 3px rgba(15, 23, 42, 0.08)')
  set('--ui-shell-sidebar-bg', config['--color-sidebar-bg'])
  set('--ui-shell-sidebar-border', config['--color-sidebar-border'])
  set('--ui-shell-sidebar-item', config['--color-sidebar-item'])
  set('--ui-shell-sidebar-icon', config['--color-sidebar-icon'])
  set('--ui-shell-sidebar-hover-bg', config['--color-sidebar-hover-bg'])
  set('--ui-shell-sidebar-active-bg', config['--color-sidebar-active-bg'])
  set('--ui-shell-sidebar-active-bg-hover', config['--color-sidebar-active-bg-hover'])
  set('--ui-shell-sidebar-active-text', config['--color-sidebar-active-text'])
  set('--ui-shell-sidebar-active-icon', config['--color-sidebar-active-icon'])
  set('--ui-shell-sidebar-section-bg', config['--color-sidebar-section-bg'])
  set('--ui-shell-popover-bg', '#ffffff')
  set('--ui-shell-popover-border', '#e2e8f0')
  set('--ui-shell-popover-shadow', '0 12px 40px rgba(15, 23, 42, 0.1)')

  set('--ui-table-head-bg', config['--color-table-header-bg'])
  set('--ui-table-head-border', config['--color-table-border'])
  set('--ui-table-head-text', config['--color-table-header-text'])
  set('--ui-table-row-hover-bg', config['--color-table-row-hover'])
  set('--ui-table-row-selected-bg', '#e0e7ff')
  set('--ui-table-row-selected-hover-bg', '#c7d2fe')
  set('--ui-table-pagination-bg', '#fafafa')
  set('--ui-table-wrapper-border', 'rgba(15, 23, 42, 0.08)')
  set('--ui-table-cell-border', 'rgba(15, 23, 42, 0.06)')
  set('--ui-table-nested-head-bg', '#dbeafe')
  set('--ui-table-nested-head-text', '#1e3a8a')
  set('--ui-table-nested-head-border', '#93c5fd')
}
